"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "checkPosition", {
  enumerable: true,
  get: function get() {
    return _zones.checkPosition;
  }
});
exports["default"] = void 0;
Object.defineProperty(exports, "getDeliveryFees", {
  enumerable: true,
  get: function get() {
    return _zones.getDeliveryFees;
  }
});
Object.defineProperty(exports, "getSubZoneByZipcode", {
  enumerable: true,
  get: function get() {
    return _zones.getSubZoneByZipcode;
  }
});
Object.defineProperty(exports, "getZipcode", {
  enumerable: true,
  get: function get() {
    return _zones.getZipcode;
  }
});
Object.defineProperty(exports, "getZipcodesBySubZoneName", {
  enumerable: true,
  get: function get() {
    return _zipcodes.getZipcodesBySubZoneName;
  }
});
Object.defineProperty(exports, "getZone", {
  enumerable: true,
  get: function get() {
    return _zones.getZone;
  }
});
Object.defineProperty(exports, "getZoneBySubZoneName", {
  enumerable: true,
  get: function get() {
    return _zones.getZoneBySubZoneName;
  }
});
Object.defineProperty(exports, "getZoneSubZones", {
  enumerable: true,
  get: function get() {
    return _zones.getZoneSubZones;
  }
});
Object.defineProperty(exports, "getZonesByCountry", {
  enumerable: true,
  get: function get() {
    return _zones.getZonesByCountry;
  }
});
Object.defineProperty(exports, "isInZone", {
  enumerable: true,
  get: function get() {
    return _zones.isInZone;
  }
});
Object.defineProperty(exports, "isZipcodeCovered", {
  enumerable: true,
  get: function get() {
    return _zipcodes.isZipcodeCovered;
  }
});
Object.defineProperty(exports, "validZipcodes", {
  enumerable: true,
  get: function get() {
    return _zipcodes.validZipcodes;
  }
});
Object.defineProperty(exports, "validZipcodesWithLabels", {
  enumerable: true,
  get: function get() {
    return _zipcodes.validZipcodesWithLabels;
  }
});
Object.defineProperty(exports, "zones", {
  enumerable: true,
  get: function get() {
    return _zones.zones;
  }
});
var _zipcodes = require("./zoning/zipcodes");
var _zones = require("./zoning/zones");
var _default = exports["default"] = _zipcodes.checkError;